/**
 * i18n 国际化配置
 *
 * 功能：
 * - 支持多语言切换
 * - 自动加载语言包
 * - 持久化语言偏好
 */
import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import en from './en'

/**
 * 支持的语言列表
 */
export const SUPPORT_LOCALES = ['zh-CN', 'en'] as const

export type SupportLocale = (typeof SUPPORT_LOCALES)[number]

/**
 * 从 localStorage 获取保存的语言偏好
 */
function getStoredLocale(): SupportLocale {
  const stored = localStorage.getItem('admin-locale')
  if (stored && SUPPORT_LOCALES.includes(stored as SupportLocale)) {
    return stored as SupportLocale
  }
  // 默认使用中文
  return 'zh-CN'
}

/**
 * 创建 i18n 实例
 */
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: {
    'zh-CN': zhCN,
    en: en,
  },
  globalInjection: true, // 全局注入 $t 函数
})

export default i18n
